import { UserRole } from '../types/types';

/** Roles allowed to sign in to the Marketing portal */
export const MARKETING_PORTAL_ROLES: UserRole[] = [
  UserRole.Admin,
  UserRole.MarketingAdmin,
];

/** Inbox: WhatsApp, inquiries, website contact enquiries */
export const WHATSAPP_MODULE_ROLES: UserRole[] = [
  UserRole.Admin,
  UserRole.MarketingAdmin,
];

export const INQUIRIES_MODULE_ROLES: UserRole[] = [
  UserRole.Admin,
  UserRole.MarketingAdmin,
];

export const WEBSITE_MODULE_ROLES: UserRole[] = [
  UserRole.Admin,
  UserRole.MarketingAdmin,
];

/** Analytics dashboards (customers, sessions, funnels, links, activities, SEO) */
export const DASHBOARD_MODULE_ROLES: UserRole[] = [
  UserRole.Admin,
  UserRole.MarketingAdmin,
];

/** Lead database / enrichment module */
export const LEADS_MODULE_ROLES: UserRole[] = [
  UserRole.Admin,
  UserRole.MarketingAdmin,
];

/** SEO dashboard + keyword management */
export const SEO_PORTAL_ROLES: UserRole[] = [
  UserRole.Admin,
  UserRole.MarketingAdmin,
];

export const SEO_KEYWORD_WRITE_ROLES: UserRole[] = [
  UserRole.Admin,
];
